import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useChains from '../useChains';

const SingleChain = () => {
  const { t } = useTranslation();
  const { singleData, chainsCompanies, loading } = useChains(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const dataKeys = [{ key: 'title', text: t('Titolo') }];

  const title = isSuccessUpdatePage
    ? t('CHAIN WAS SUCCESSFULLY UPDATED.')
    : t('Catena');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('Catena')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item>
                <b className={styles.itemName}>{item.text}</b>
                {singleData?.[item.key]}
              </List.Item>
            )}
          />
          {chainsCompanies.length > 0 && (
            <List
              bordered
              style={{ marginTop: 24 }}
              dataSource={chainsCompanies.map(
                (i) => `${i.title} (${i.shopping_center?.title})`,
              )}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          )}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/chains/${singleData?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/chains'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleChain;
